module.exports = __webpack_public_path__ + "static/media/fa-brands-400.a12d50b7.svg";